import { all } from "redux-saga/effects";

import { caseDocumentsSaga } from "shared/sagas/adminCaseDocuments";
import { adminCasesSaga } from "shared/sagas/adminCasesSaga";
import { adminPatientSaga } from "shared/sagas/adminPatientSaga";
import { adminSlidesSaga } from "shared/sagas/adminSlidesSaga";
import { aiSaga } from "shared/sagas/aiSaga";
import { assessmentSaga } from "shared/sagas/assessmentSaga";
import { authSaga } from "shared/sagas/authSaga";
import { caseDetailSaga } from "shared/sagas/caseDetailSaga";
import { casesSaga } from "shared/sagas/casesSaga";
import { disclaimersSaga } from "shared/sagas/disclaimerSaga";
import { flagsSaga } from "shared/sagas/flagsSaga";
import { labOrdersSaga } from "shared/sagas/labOrdersSaga";
import { listUsersSaga } from "shared/sagas/listUsersSaga";
import { messagesSaga } from "shared/sagas/messagesSaga";
import { slideDetailSaga } from "shared/sagas/slideDetailSaga";
import { slideTileSaga } from "shared/sagas/slideTileSaga";
import { stainsSaga } from "shared/sagas/stainsSaga";
import { generateAsyncSagas } from "shared/utils/asyncActions";

// Import files which create Sagas with createAsyncSaga()
import "shared/actions/caseReportActions";
import "shared/actions/authActions";
import "shared/actions/sysActions";
import "shared/actions/frontLoaderActions";
import "shared/actions/aiActions";
import "shared/actions/caseDetailActions";
import "shared/actions/siteSpecificCodesActions";
import "shared/actions/labActions";

export default function* rootSaga() {
  yield all([
    authSaga(),
    casesSaga(),
    caseDetailSaga(),
    caseDocumentsSaga(),
    flagsSaga(),
    disclaimersSaga(),
    labOrdersSaga(),
    slideDetailSaga(),
    slideTileSaga(),
    listUsersSaga(),
    stainsSaga(),
    assessmentSaga(),
    aiSaga(),
    messagesSaga(),
    adminCasesSaga(),
    adminPatientSaga(),
    adminSlidesSaga(),
    ...generateAsyncSagas(),
  ]);
}
